module.exports = __webpack_public_path__ + "static/img/胸腹衣.27529087.jpg";